import(/* webpackMode: "eager" */ "/vercel/path0/ui/src/app/vaults/strategy-vaults/page.tsx");
